import api from './api';
import type { ServiceSource } from './serviceCategoryService';
import { serviceSourceOptions } from './serviceCategoryService';

export type StaffCommissionType = 'fixed_amount' | 'payment_ratio';

export interface ServiceProductRegion {
  regionId?: string;
  provinceName: string;
  cityName: string;
  districtName: string;
}

export const staffCommissionTypeOptions = [
  { label: '固定金额', value: 'fixed_amount' as StaffCommissionType },
  { label: '支付比例', value: 'payment_ratio' as StaffCommissionType },
];

export const staffCommissionTypeLabelMap: Record<StaffCommissionType, string> = {
  fixed_amount: '固定金额',
  payment_ratio: '支付比例',
};

export interface ServiceProduct {
  id: string;
  categoryId: string;
  categoryName?: string;
  name: string;
  description?: string;
  serviceDetail?: string;
  imageUrl: string;
  tags: string[];
  serviceRegions: ServiceProductRegion[];
  staffCommissionType: StaffCommissionType;
  staffCommissionValue: number;
  unmatchedCityCommissionValue: number;
  price: number;
  originalPrice: number;
  extraUnitPrice: number;
  source: ServiceSource;
  sort: number;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceProductListParams {
  page?: number;
  pageSize?: number;
  name?: string;
  source?: ServiceSource;
  categoryId?: string;
  status?: number;
}

export interface ServiceProductListResponse {
  list: ServiceProduct[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateServiceProductRequest {
  categoryId: string;
  name: string;
  description?: string;
  serviceDetail?: string;
  imageUrl: string;
  tags?: string[];
  serviceRegions: ServiceProductRegion[];
  staffCommissionType: StaffCommissionType;
  staffCommissionValue: number;
  unmatchedCityCommissionValue: number;
  price?: number;
  originalPrice?: number;
  extraUnitPrice?: number;
  sort?: number;
  status?: number;
}

export interface UpdateServiceProductRequest {
  categoryId?: string;
  name?: string;
  description?: string;
  serviceDetail?: string;
  imageUrl?: string;
  tags?: string[];
  serviceRegions?: ServiceProductRegion[];
  staffCommissionType?: StaffCommissionType;
  staffCommissionValue?: number;
  unmatchedCityCommissionValue?: number;
  price?: number;
  originalPrice?: number;
  extraUnitPrice?: number;
  sort?: number;
  status?: number;
}

export { serviceSourceOptions };

export const getServiceProducts = (params?: ServiceProductListParams) => api.get<ServiceProductListResponse>('/service-products', { params });

export const getServiceProduct = (id: string) => api.get<ServiceProduct>(`/service-products/${id}`);

export const createServiceProduct = (data: CreateServiceProductRequest) => api.post<ServiceProduct>('/service-products', data);

export const updateServiceProduct = (id: string, data: UpdateServiceProductRequest) => api.put<ServiceProduct>(`/service-products/${id}`, data);

export const deleteServiceProduct = (id: string) => api.delete(`/service-products/${id}`);
